import { CreditCard, Loader2, QrCode } from "lucide-react";
import { Button } from "@/components/ui/button";

export const PayButtons = ({ loading, onCard, onPix, card = true, prefix = "billing" }) => (
  <div className="mt-6 grid gap-2">
    {card && (
      <Button onClick={onCard} disabled={!!loading} className="h-11 w-full rounded-full font-semibold" data-testid={`${prefix}-subscribe-button`}>
        {loading === "card" ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <CreditCard className="mr-2 h-4 w-4" />} Assinar no cartão (automático)
      </Button>
    )}
    <Button variant="outline" onClick={onPix} disabled={!!loading} className="h-11 w-full rounded-full border-emerald-400/60 bg-transparent font-semibold text-emerald-200" data-testid={`${prefix}-pix-button`}>
      {loading === "pix" ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : <QrCode className="mr-2 h-4 w-4" />} Pagar 1 mês com Pix
    </Button>
    <p className="text-center text-xs text-slate-500">No Pix, você gera um QR Code a cada mês. Avisamos por e-mail antes do vencimento.</p>
  </div>
);
